"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAnchorNavigationHideItemOnDetailPage = exports.setAnchorNavigationHideItemOnDetailPage = exports.removePendingVehciles = exports.setPendingVehicles = exports.setOutdatedCount = exports.resetResultsCount = exports.incrementResultsCount = exports.setLoader = exports.setResultsViewType = exports.setSearchAgentAuthentication = exports.setShowDistance = exports.SET_SHOW_DISTANCE = exports.DELETE_ANCHOR_NAVIGATION_HIDE_ITEM_ON_DETAIL_PAGE = exports.SET_ANCHOR_NAVIGATION_HIDE_ITEM_ON_DETAIL_PAGE = exports.SET_RESULTS_VIEW_TYPE = exports.SET_SEARCH_AGENT_AUTHENTICATION = exports.REMOVE_PENDING = exports.SET_PENDING = exports.RESET_RESULTS_COUNT = exports.SET_OUTDATEDCOUNT = exports.INCREMENT_RESULTS_COUNT = exports.SET_LOADER = void 0;
exports.SET_LOADER = 'SET_LOADER';
exports.INCREMENT_RESULTS_COUNT = 'INCREMENT RESULTS COUNT';
exports.SET_OUTDATEDCOUNT = 'SET OUTDATEDCOUNT';
exports.RESET_RESULTS_COUNT = 'RESET RESULTS COUNT';
exports.SET_PENDING = 'SET_PENDING';
exports.REMOVE_PENDING = 'REMOVE_PENDING';
exports.SET_SEARCH_AGENT_AUTHENTICATION = 'SET_SEARCH_AGENT_AUTHENTICATION';
exports.SET_RESULTS_VIEW_TYPE = 'SET_RESULTS_VIEW_TYPE';
exports.SET_ANCHOR_NAVIGATION_HIDE_ITEM_ON_DETAIL_PAGE = 'SET HIDE_ITEM_ON_DETAIL_PAGE';
exports.DELETE_ANCHOR_NAVIGATION_HIDE_ITEM_ON_DETAIL_PAGE = 'DELETE HIDE_ITEM_ON_DETAIL_PAGE';
exports.SET_SHOW_DISTANCE = 'SET_SHOW_DISTANCE';
const setShowDistance = ({ state, feature = 'SHOW DISTANCE' }) => ({
    type: `${feature} ${exports.SET_SHOW_DISTANCE}`,
    payload: state,
    meta: { feature },
});
exports.setShowDistance = setShowDistance;
const setSearchAgentAuthentication = ({ searchAgentAuthentication = false }, feature = '[SearchAgent]') => ({
    type: `${feature} ${exports.SET_SEARCH_AGENT_AUTHENTICATION}`,
    payload: searchAgentAuthentication,
    meta: { feature },
});
exports.setSearchAgentAuthentication = setSearchAgentAuthentication;
const setResultsViewType = ({ resultsViewType = '' }, feature = 'resultsViewType') => ({
    type: `${feature} ${exports.SET_RESULTS_VIEW_TYPE}`,
    payload: resultsViewType,
    meta: { feature },
});
exports.setResultsViewType = setResultsViewType;
const setLoader = ({ state, feature }) => ({
    type: `${feature} ${exports.SET_LOADER}`,
    payload: state,
    meta: { feature },
});
exports.setLoader = setLoader;
const incrementResultsCount = (state = {}, feature = 'vehicles') => ({
    type: `${feature} ${exports.INCREMENT_RESULTS_COUNT}`,
    payload: state,
    meta: { feature },
});
exports.incrementResultsCount = incrementResultsCount;
const resetResultsCount = (state = {}, feature = 'vehicles') => ({
    type: `${feature} ${exports.RESET_RESULTS_COUNT}`,
    payload: state,
    meta: { feature },
});
exports.resetResultsCount = resetResultsCount;
const setOutdatedCount = ({ count = 0 }, feature = 'last favorites') => ({
    type: `${feature} ${exports.SET_OUTDATEDCOUNT}`,
    payload: count,
    meta: { feature },
});
exports.setOutdatedCount = setOutdatedCount;
const setPendingVehicles = ({ vehicleId }, feature = 'vehicles') => ({
    type: `${feature} ${exports.SET_PENDING}`,
    payload: vehicleId,
    meta: { feature },
});
exports.setPendingVehicles = setPendingVehicles;
const removePendingVehciles = ({ vehicleId }, feature = 'vehicles') => ({
    type: `${feature} ${exports.REMOVE_PENDING}`,
    payload: vehicleId,
    meta: { feature },
});
exports.removePendingVehciles = removePendingVehciles;
const setAnchorNavigationHideItemOnDetailPage = (itemId) => ({
    type: `[ANCHOR_NAVIGATION] ${exports.SET_ANCHOR_NAVIGATION_HIDE_ITEM_ON_DETAIL_PAGE}`,
    payload: itemId,
});
exports.setAnchorNavigationHideItemOnDetailPage = setAnchorNavigationHideItemOnDetailPage;
const resetAnchorNavigationHideItemOnDetailPage = () => ({
    type: `[ANCHOR_NAVIGATION] ${exports.DELETE_ANCHOR_NAVIGATION_HIDE_ITEM_ON_DETAIL_PAGE}`,
    payload: [],
});
exports.resetAnchorNavigationHideItemOnDetailPage = resetAnchorNavigationHideItemOnDetailPage;
//# sourceMappingURL=ui.js.map